import { stringify } from "query-string";

interface params {
  searchString: string;
  circuitCode?: string;
  gender?: string;
}

const playersEndPoint = "/tennis/api/PlayerApi/GetPlayerSearch?";

export async function getPlayers(
  searchString: string,
  circuitCode?: string,
  gender?: string
) {
  let params: params = {
    searchString
  };

  if (circuitCode) {
    params["circuitCode"] = circuitCode;
  }

  if (gender) {
    params["gender"] = gender;
  }

  const response = await fetch(
    `${process.env.HOST}${playersEndPoint}${stringify(params)}`
  );
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}
